import { Link } from 'src/components';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useTrackedClickHandler } from 'src/analytics/trackedClickHandler';
import { useEventClickAppStore } from 'src/analytics/useEventClickAppStore';
import { useExternalHref } from 'src/hooks/useExternalHref';
import { intlGetMessagesLocale } from 'src/utils/intl';
import { msgs } from './messages';
import * as S from './styles';

/**
 * Images for new languages you can find here:
 * https://play.google.com/intl/en_us/badges/
 */

export const LinkToGooglePlay: FC = props => {
  const intl = useIntl();
  const messagesLocale = intlGetMessagesLocale(intl.locale);

  const downloadFromGooglePlay = useRef<HTMLAnchorElement | null>(null);

  const eventClickAppStore = useEventClickAppStore('google-play');
  const trackedOnClick = useTrackedClickHandler(eventClickAppStore);

  const [image, setImage] = useState('');

  useEffect(() => {
    void (async () => {
      const module = await import(`./icons/get-it-on-google-play-badge-${messagesLocale}.svg`);
      setImage(module.default);
    })();
  }, [messagesLocale]);

  const downloadFrom = intl.formatMessage(msgs.downloadFrom);
  const googlePlay = intl.formatMessage(msgs.googlePlay);
  const googlePlayHref = useExternalHref({
    linkType: 'memrise-google-play',
  });

  return (
    <Link href={googlePlayHref} passHref legacyBehavior>
      <S.GooglePlayBadgeWrapper {...props} onClick={trackedOnClick} ref={downloadFromGooglePlay}>
        <S.GooglePlayBadge $image={image} $locale={messagesLocale}>
          {downloadFrom} {googlePlay}
        </S.GooglePlayBadge>
      </S.GooglePlayBadgeWrapper>
    </Link>
  );
};

export default LinkToGooglePlay;
